
import {
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { NotificacoesStore } from "../../stores/notificacoes/NotificacoesStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import {
  MDBBtn,
  MDBCol,
  MDBRow,
} from "mdbreact";
import HeaderTarja from "./HeaderTarja";
import Tour from "reactour";
import { CentralStore } from "../../stores/erros/CentralStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import { SitfisStore } from "../../stores/sitfis/SitifisStore";
import { CaixaPostalStore } from "../../stores/caixa-postal/CaixaPostalStore";
import { DecSefaStore } from "../../stores/dec_sefa/DecSefaStore";
import Badge from '@mui/material/Badge';
import { Dialog, DialogContent, IconButton } from "@mui/material";
import { LegislacaoStore } from "../../stores/legislacao/LegislacaoStore";
import { Button, Classes, Tooltip } from "@blueprintjs/core";
import LoadingModal from "../loading/LoadingModal";
import Sidebar from "../sidebar/Sidebar";
import { UtilitarioStore } from "../../stores/utilitarios/UtilitarioStore";
import EqualizaNcm from "../utilitarios/equaliza-ncm";
import WarningAdmin from "./WarningAdmin";
import Cron from "./Cron";
import NavMenu from "./NavMenu";
import { DetStore } from "../../stores/det/DetStore";
import { LoginStore } from "../../stores/login/LoginStore";
import { StatusStore } from "../../stores/status/StatusStore";

require("../../assets/css/components/Header.css");

export interface SimpleDialogProps {
  open: boolean;
  onClose: (value: string) => void;
}

interface State {
  collapseID: boolean
  open_noty: boolean
  open_noty_mobile: boolean
  mobileOpen: boolean
  submenu: boolean
  headerLoaded: boolean
}

@observer
export default class Header extends React.Component<any, State> {


  obs = observable({
    certificados_expirados: 0 as number,
    qty_noti: 0 as number,
    view_noti: true as boolean,
    handleGoBackup: false as boolean,
    handleGoConfig: false as boolean,
    backup: "" as string,
    view_noti_adm: false as boolean,
    qty_noti_adm: 0 as number,
    auth: "" as string,
    list: [] as String[],
    titulo: "" as string,
    descricao: "" as string,
    tipo: "" as string,
    notiCertfi: false as boolean,
    notifyModal: false as boolean,
    notifySitfis: false as boolean,

    view_msg: true as boolean,
    cronModal: false as boolean,

  })

  constructor(props) {
    super(props);

    this.state = {
      collapseID: false,
      open_noty: false,
      open_noty_mobile: false,
      mobileOpen: false,
      submenu: false,
      headerLoaded: false,
    };

  }

  async componentDidMount() {

    this.setState({ headerLoaded: true });

    await EmpresaStore.load();
    await PerfilStore.load();
    await PerfilStore.handleUserDominio()
    await SitfisStore.handleErrosAutomatico()
    await CaixaPostalStore.handleConsultaMensagens()
    await DecSefaStore.handleConsultaMensagens()
    await DetStore.handleConsultaMensagens()

    this.obs.auth = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.autenticacao : "";

    var qty_not = 0;

    if (AppStore.obs1.stats.cert_venc >= 1) {
      qty_not += 1;
    }

    if (!PerfilStore.obs.contrato_assinado) {
      qty_not += 1;
    }

    if (CentralStore.obs.total_nao_calculado >= 1) {
      qty_not += 1;
    }

    if (SitfisStore.obs.erros_sitfis_auto.length >= 1) {
      qty_not += 1;
    }

    this.obs.notiCertfi = this.comparar(moment(AppStore.obs1.usuario.conta.certificado).format("DD/MM/YYYY"));

    if (this.obs.notiCertfi) {
      qty_not += 1;
    }

    this.obs.qty_noti = qty_not;

    if (qty_not == 0) {
      this.obs.view_noti = true;
    } else {
      this.obs.view_noti = false;
    }

  }

  componentDidUpdate(prevProps, prevState) {

    if (!prevState.headerLoaded && AppStore.obs1.usuario) {
      this.setState({ headerLoaded: true });
    }

  }

  handleGoAtendimento = () => {
    window.open("http://help.fipo.com.br/", "_blank");
    this.handleClosePerfilModal()
  };

  handleClickNotification = () => {
    this.obs.view_noti = true;
  };

  handleClickNotificationAdmin = () => {
    this.obs.view_noti_adm = true;
  };

  handleGoFinanceiro = () => {
    AppStore.setLocation("/historico-financeiro");
  };
  handleClosePerfilModal = () => {
    let cd: any = document.getElementsByClassName("imagemPerfilDropDown")

    if (cd.length) cd[0].click()

  }

  handleGoPerfil = () => {
    AppStore.setLocation("/perfil");
    this.handleClosePerfilModal()
  };

  handleGoLogs = () => {
    AppStore.setLocation("/logs");
    this.handleClosePerfilModal()
  };

  toggleCollapse = (collapseID) => {
    this.setState((prevState) => ({
      collapseID: prevState.collapseID !== collapseID ? collapseID : false
    }));
  };

  handleGoNotification = async (pagina: string) => {

    let cd: any = document.getElementsByClassName("idDropdownNotification")

    if (cd.length) cd[0].click()


    this.setState({ open_noty_mobile: false, open_noty: false });

    if (pagina == "calculo-icms") {

      await LegislacaoStore.get_pdf("icms")
      return

    }

    if (pagina == "decreto-icms") {

      await LegislacaoStore.get_pdf("decreto")
      return

    }

    AppStore.setLocation(pagina);

  };

  handleSuporte = () => {
    window.open("https://api.whatsapp.com/send?phone=54920004300&text=Ol%C3%A1!")
    this.handleClosePerfilModal()
  };

  handleGoNotificationCaixa = (pagina: string) => {

    let cd: any = document.getElementsByClassName("idDropdownCaixaEntrada")
    if (cd.length) cd[0].click()

    AppStore.setLocation(pagina);

    if (CaixaPostalStore.obs.mensagens_pendentes.length > 0) {
      CaixaPostalStore.obs.open_empresas_mensagens = true
    }
  }

  handleGoNotificationDec = (pagina: string) => {

    let cd: any = document.getElementsByClassName("idDropdownCaixaEntrada")
    if (cd.length) cd[0].click()

    AppStore.setLocation(pagina);

    if (DecSefaStore.obs.mensagens_pendentes.length > 0) {
      DecSefaStore.obs.open_empresas_mensagens = true
    }
  }

  handleGoNotificationResultados = (pagina: string) => {
    ResultadoStore.obs.selectedResultadosTab = "contestacoes"
    ResultadoStore.handleConsultaTodas(1, 15);
    ResultadoStore.handldeItensProcessando();

    AppStore.setLocation(pagina);
  };

  handleLogout() {
    LoginStore.resetTokens()
    window.location.href = "/"
  }

  comparar(certificado) {
    var partesData = certificado.split("/");
    var data = new Date(partesData[2], partesData[1] - 1, partesData[0]);
    var hoje = new Date();

    hoje = new Date(hoje.getFullYear(), hoje.getUTCMonth(), hoje.getUTCDate());

    if (data < hoje) {
      return true;
    }
  }

  handleGoNotificationSitfis() {

    let cd: any = document.getElementsByClassName("idDropdownNotification")

    if (cd.length) cd[0].click()


    this.setState({ open_noty_mobile: false, open_noty: false });

    AppStore.setLocation("/sitfis");

    this.obs.notifySitfis = true
  }

  async handleRemoveErros() {
    await SitfisStore.handleDeleteErros()
    await SitfisStore.handleErrosAutomatico()
    this.obs.notifySitfis = false
  }

  handleClose = () => {

    this.setState({ open_noty: false });

  };

  handleClickOpen = () => {

    this.setState({ open_noty: true });

  };

  handleMobileClose = () => {

    this.setState({ open_noty_mobile: false });

  };

  handleClickMobileOpen = () => {

    this.setState({ open_noty_mobile: true });

  };

  handleDrawerToggle = () => {

    this.setState({ mobileOpen: !this.state.mobileOpen });

  };

  handleGoNotificationDet = (pagina: string) => {

    let cd: any = document.getElementsByClassName("idDropdownCaixaEntrada")
    if (cd.length) cd[0].click()

    AppStore.setLocation(pagina);

    if (DetStore.obs.mensagens_pendentes.length > 0) {
      DetStore.obs.open_empresas_mensagens = true
    }
  }

  perfil_menu() {

    if (AppStore.obs1.usuario.user_empresa) {
      return (
        <IconButton style={{ marginLeft: 15 }} onClick={() => this.handleLogout()}>
          <img src="/images/logout.svg" width="22px;" />
        </IconButton>
      )
    }

    return (
      <MDBDropdown dropleft className="dropdownNotification badge-count">
        <MDBDropdownToggle color="default">
          {PerfilStore.obs.imagem != ""
            ?
            <div className="imagem_perfil imagemPerfilDropDown" style={{ backgroundImage: "url(data:image/jpge;base64," + PerfilStore.obs.imagem + ")", }} />
            :
            <div className="imagem_perfil imagemPerfilDropDown" style={{ backgroundImage: "url(\"/images/perfil.png\")", }} />
          }
        </MDBDropdownToggle>
        <MDBDropdownMenu basic>
          <div className="headerNotifications">
            <h4>
              <MDBRow>
                <MDBCol md="9" className="">
                  {AppStore.obs1.usuario.conta.nome}
                </MDBCol>
                <MDBCol md="3" className="">
                  <p onClick={() => this.handleLogout()} role="button" className="btn_sair nz-nav-menu-item" style={{ marginTop: "-26px", fontWeight: 600, cursor: "pointer" }}>
                    <img src="/images/logout.svg" width="22px;" />
                    Sair
                  </p>
                </MDBCol>
              </MDBRow>
            </h4>
          </div>

          <MDBCol md="12" className="mb-12 text-center">
            <div className="perfilUser modal_perfil">

              <div className="imagem_perfil_modal" style={{
                backgroundImage: PerfilStore.obs.imagem != ""
                  ? "url(data:image/jpge;base64," + PerfilStore.obs.imagem + ")"
                  : "url(\"/images/perfil.png\")"
              }} />

              <h2>{AppStore.obs1.usuario.conta.nome}</h2>

            </div>

            <div className="tabs">
              <li>
                <button onClick={this.handleGoPerfil}>Perfil</button>
              </li>
            </div>

            <br />

            <MDBCol md="12">
              {AppStore.obs1.usuario.admin &&
                (<>
                  <MDBBtn className="btnDefault" onClick={(e) => { this.obs.notifyModal = true; this.handleClosePerfilModal() }}>
                    Notificar Contas
                  </MDBBtn>
                  &nbsp;&nbsp;
                  <MDBBtn className="btnDefault" onClick={(e) => { this.obs.cronModal = true; this.handleClosePerfilModal() }}>
                    Liberar Cron
                  </MDBBtn>
                </>)}

            </MDBCol>

          </MDBCol>

        </MDBDropdownMenu>
      </MDBDropdown>
    )
  }

  handleMenuClick = async (page: string) => {

    this.setState({
      mobileOpen: false

    });

    this.handleGoNotification(page)

  };

  onCloseEqualiza() {

    UtilitarioStore.obs.open_equaliza_ncm = false

    UtilitarioStore.obs.loading_equaliza_ncm = false

  }

  render() {

    let badge_dec = DecSefaStore.obs.mensagens_pendentes.reduce((acc, obj) => acc + obj.count, 0)
    let badge_det = DetStore.obs.mensagens_pendentes.reduce((acc, obj) => acc + obj.count, 0)
    let badge_caixa_postal = CaixaPostalStore.obs.mensagens_pendentes.length

    let total_badge = badge_caixa_postal + badge_dec + badge_det

    let warnings = NotificacoesStore.obs.warnings?.map(value => {
      return (
        <p>
          <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp;
          Serviço <b>{value.modulo}</b> indisponível no momento.
        </p>
      )
    })

    if (CaixaPostalStore.obs.mensagens_pendentes.length > 0) {
      this.obs.view_msg = false
    }

    const SimpleDialog = (props: SimpleDialogProps) => {

      return (<Dialog onClose={props.onClose} open={props.open} sx={{ zIndex: 9999 }}>

        <DialogContent sx={{ width: 500 }}>
          <MDBDropdown dropleft className="dropdownNotification badge-count">

            <div className="headerNotifications">
              <b>
                Notificações {moment().format("L")}{" "}
                <Badge style={{ float: "right" }} badgeContent={this.obs.qty_noti + total_badge} color="primary" />
              </b>
            </div>

            <p onClick={(e) => this.handleGoNotification("/dec-sefa")}>
              <Badge badgeContent=" " color="primary" variant="dot" /> &nbsp;&nbsp;
              Domicílio Eletrônico do Contribuinte (SEFA).{" "}
              <b>Clique aqui</b>
            </p>

            <p onClick={(e) => this.handleGoNotification("/caixa-postal")}>
              <Badge badgeContent=" " color="primary" variant="dot" /> &nbsp;&nbsp;
              Caixa Postal.{" "}
              <b>Clique aqui</b>
            </p>

            <p onClick={(e) => this.handleGoNotification("/det")}>
              <Badge badgeContent=" " color="primary" variant="dot" /> &nbsp;&nbsp;
              Domicílio Eletrônico Trabalhista (DET).{" "}
              <b>Clique aqui</b>
            </p>

            <p onClick={(e) => this.handleGoNotification("/releases")}>
              <Badge badgeContent=" " color="primary" variant="dot" /> &nbsp;&nbsp;
              Visualize as últimas atualizações do sistema.{" "}
              <b>Clique aqui</b>
            </p>

            {!PerfilStore.obs.contrato_assinado ?
              <p
                onClick={(e) => this.handleGoNotification("/assinar-contrato",)}>
                <Badge badgeContent=" " color="warning" variant="dot" /> &nbsp;&nbsp;
                A assinatura do seu contrato está pendente.
                {" "}
                <b>Clique aqui para assinar</b>
              </p>
              :
              <p
                onClick={(e) => this.handleGoNotification("/assinar-contrato",)}>
                <Badge badgeContent=" " color="success" variant="dot" /> &nbsp;&nbsp;
                Contrato Assinado.
                {" "}
                <b>Clique aqui para visualizar</b>
              </p>
            }

            {AppStore.obs1.stats.cert_venc >= 1 &&
              (
                <p onClick={(e) => { EmpresaStore.obs.certificado = "1"; EmpresaStore.obs.status = ""; this.handleGoNotification("/empresas") }}>
                  <Badge badgeContent=" " color="warning" variant="dot" /> &nbsp;&nbsp;
                  Você possui{" "}
                  <b>
                    {AppStore.obs1.stats.cert_venc}{" "}
                    {AppStore.obs1.stats.cert_venc == 1
                      ? "empresa"
                      : "empresas"}
                  </b>{" "}
                  com certificado expirado.
                </p>
              )}

            {CentralStore.obs.total_nao_calculado >= 1 &&
              (
                <p onClick={(e) => this.handleGoNotification("/erros-notas")}>
                  <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp;
                  <b>
                    {CentralStore.obs.total_nao_calculado}{" "}
                    {CentralStore.obs.total_nao_calculado <= 1
                      ? "Item não foi calculado"
                      : "Itens não foram calculados"}
                  </b>{" "}
                  corretamente. Clique aqui.
                </p>
              )}

            {this.obs.notiCertfi &&
              (
                <p onClick={(e) => this.handleGoNotification("/perfil")}>
                  <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp; Certificado do contador expirado.
                </p>
              )}

            {SitfisStore.obs.erros_sitfis_auto.length > 0 &&
              (
                <p onClick={(e) => { this.handleGoNotificationSitfis(); props.onClose }}>
                  <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp; Você possui{" "}
                  <b>
                    {SitfisStore.obs.erros_sitfis_auto.length}{" "}
                    {SitfisStore.obs.erros_sitfis_auto.length <= 1
                      ? "erro no Situação Fiscal (RFB) Automático."
                      : "erros no Situação Fiscal (RFB) Automático."}
                  </b>{" "}
                  Clique aqui.
                </p>
              )}

            {warnings}
          </MDBDropdown>
        </DialogContent>

      </Dialog>)

    }

    const start = <div className="container-img-navbar">
      <img src='/images/logo-novo.png' className="logo-navbar" style={{ cursor: "pointer" }} onClick={() => this.setState({ submenu: true })} />
    </div>

    const end = (
      <div className="flex align-items-center gap-2" style={{ display: "flex" }}>

        {NotificacoesStore.obs.warnings.length > 0 ?
          <div data-tut="warnings">
            <MDBDropdown dropleft className="dropdownNotification badge-count">
              <MDBDropdownToggle color="default">
                <IconButton size="small" color="inherit" edge="end">
                  <Badge onClick={() => NotificacoesStore.obs.isTourOpen = false} className="hvr-buzz warning-buzz" badgeContent={NotificacoesStore.obs.warnings.length} color="primary">
                    <img src="/images/warning.png" width="25px;" />
                  </Badge>
                </IconButton>
              </MDBDropdownToggle>
              <div id="DrowpDownWarning">
                <MDBDropdownMenu basic>
                  <div className="headerNotifications">
                    <h4>
                      Notificações {moment().format("L")}{" "}
                    </h4>
                  </div>
                  {warnings}
                </MDBDropdownMenu>
              </div>
            </MDBDropdown>
          </div>
          : <></>}

        {!AppStore.obs1.usuario.user_empresa ?
          <MDBDropdown dropleft className="dropdownNotification badge-count">
            <MDBDropdownToggle className="idDropdownCaixaEntrada" color="default">
              <IconButton size="small" color="inherit" edge="end">
                <Badge className={total_badge == 0 ? "" : "hvr-buzz warning-buzz"} badgeContent={total_badge} color="primary">
                  <img src="/images/e-mail.png" width="25px;" />
                </Badge>
              </IconButton>
            </MDBDropdownToggle>

            <MDBDropdownMenu basic>
              <div className="headerNotifications">
                <h4>
                  Caixa de Entrada {moment().format("L")}{" "}
                  <Badge style={{ float: "right" }} badgeContent={total_badge} color="primary" />
                </h4>
              </div>

              <p onClick={(e) => this.handleGoNotificationCaixa("/caixa-postal")}>
                <Badge badgeContent=" " color={badge_caixa_postal > 0 ? "warning" : "success"} variant="dot" /> &nbsp;&nbsp;
                Caixa Postal - você possui{" "}
                <b>{badge_caixa_postal}{" "} {badge_caixa_postal == 1 ? "mensagem" : "mensagens"}</b> não lida(s).
              </p>

              {/* {(AppStore.obs1.usuario.conta.uf === "PA" || AppStore.obs1.usuario.conta.estado === "PA") ? */}
              <p onClick={(e) => this.handleGoNotificationDec("/dec-sefa")}>
                <Badge badgeContent=" " color={badge_dec > 0 ? "warning" : "success"} variant="dot" /> &nbsp;&nbsp;
                Domicílio Eletrônico do Contribuinte - você possui{" "}
                <b>{badge_dec}{" "} {badge_dec == 1 ? "mensagem" : "mensagens"}</b> não lida(s).
              </p>
              {/* : <></>} */}

              <p onClick={(e) => this.handleGoNotificationDet("/det")}>
                <Badge badgeContent=" " color={badge_det > 0 ? "warning" : "success"} variant="dot" /> &nbsp;&nbsp;
                Domicílio Eletrônico Trabalhista (DET) - você possui{" "}
                <b>{badge_det}{" "} {badge_det == 1 ? "mensagem" : "mensagens"}</b> não lida(s).
              </p>

            </MDBDropdownMenu>
          </MDBDropdown>
          : <></>}

        {!AppStore.obs1.usuario.user_empresa ?
          <MDBDropdown dropleft className="dropdownNotification badge-count">
            <MDBDropdownToggle className="idDropdownNotification" color="default">
              <IconButton size="small" color="inherit" edge="end">
                <Badge className={this.obs.qty_noti == 0
                  ? ""
                  : "pulse-notification"} badgeContent={this.obs.qty_noti} color="primary" >
                  <img src="/images/notification.svg" width="25px;" />
                </Badge>
              </IconButton>
            </MDBDropdownToggle>

            <MDBDropdownMenu basic>
              <div className="headerNotifications">
                <h4>
                  Notificações {moment().format("L")}{" "}
                  <Badge style={{ float: "right" }} badgeContent={this.obs.qty_noti} color="primary" />
                </h4>
              </div>

              <p onClick={(e) => this.handleGoNotification("/releases")}>
                <Badge badgeContent=" " color="primary" variant="dot" /> &nbsp;&nbsp;
                Visualize as últimas atualizações do sistema.{" "}
                <b>Clique aqui</b>
              </p>

              {!PerfilStore.obs.contrato_assinado ?
                <p
                  onClick={(e) => this.handleGoNotification("/assinar-contrato",)}>
                  <Badge badgeContent=" " color="warning" variant="dot" /> &nbsp;&nbsp;
                  A assinatura do seu contrato está pendente.
                  {" "}
                  <b>Clique aqui para assinar</b>
                </p>
                :
                <p
                  onClick={(e) => this.handleGoNotification("/assinar-contrato",)}>
                  <Badge badgeContent=" " color="success" variant="dot" /> &nbsp;&nbsp;
                  Contrato Assinado.
                  {" "}
                  <b>Clique aqui para visualizar</b>
                </p>
              }
              {AppStore.obs1.stats.cert_venc >= 1 &&
                (
                  <p onClick={(e) => { EmpresaStore.obs.certificado = "1"; EmpresaStore.obs.status = ""; this.handleGoNotification("/empresas") }}>
                    <Badge badgeContent=" " color="warning" variant="dot" /> &nbsp;&nbsp;
                    Você possui{" "}
                    <b>
                      {AppStore.obs1.stats.cert_venc}{" "}
                      {AppStore.obs1.stats.cert_venc == 1
                        ? "empresa"
                        : "empresas"}
                    </b>{" "}
                    com certificado expirado.
                  </p>
                )}
              {CentralStore.obs.total_nao_calculado >= 1 &&
                (
                  <p onClick={(e) => this.handleGoNotification("/erros-notas")}>
                    <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp;
                    <b>
                      {CentralStore.obs.total_nao_calculado}{" "}
                      {CentralStore.obs.total_nao_calculado <= 1
                        ? "Item não foi calculado"
                        : "Itens não foram calculados"}
                    </b>{" "}
                    corretamente. Clique aqui.
                  </p>
                )}
              {this.obs.notiCertfi &&
                (
                  <p onClick={(e) => this.handleGoNotification("/perfil")}>
                    <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp;
                    Certificado do contador expirado.
                  </p>
                )}
              {SitfisStore.obs.erros_sitfis_auto.length > 0 &&
                (
                  <p onClick={(e) => this.handleGoNotificationSitfis()}>
                    <Badge badgeContent=" " color="error" variant="dot" /> &nbsp;&nbsp;
                    Você possui{" "}
                    <b>
                      {SitfisStore.obs.erros_sitfis_auto.length}{" "}
                      {SitfisStore.obs.erros_sitfis_auto.length <= 1
                        ? "erro no Situação Fiscal (RFB) Automático."
                        : "erros no Situação Fiscal (RFB) Automático."}
                    </b>{" "}
                    Clique aqui.
                  </p>
                )}
            </MDBDropdownMenu>
          </MDBDropdown>
          : <></>}

        <SimpleDialog
          open={this.state.open_noty}
          onClose={this.handleClose}
        />

        {this.perfil_menu()}

      </div>
    );

    const endMobile = (
      <div className="flex align-items-center gap-2" style={{ display: "flex" }}>
        {!AppStore.obs1.usuario.user_empresa ?
          <IconButton style={{ marginLeft: 15 }} size="small" color="inherit" edge="end" onClick={this.handleClickMobileOpen}>
            <img src="/images/notification.svg" width="25px;" />
          </IconButton>
          : <></>}

        {this.perfil_menu()}

        <SimpleDialog
          open={this.state.open_noty_mobile}
          onClose={this.handleMobileClose}
        />
      </div>
    )

    return (
      <>
        {this.state.headerLoaded && <HeaderTarja />}

        <Tour
          onRequestClose={() => NotificacoesStore.obs.isTourOpen = false}
          steps={tourConfig}
          isOpen={NotificacoesStore.obs.isTourOpen}
          maskClassName="mask"
          className="helper"
          rounded={1} />

        <NavMenu start={start} end={end} endMobile={endMobile} />

        <LoadingModal open={LegislacaoStore.obs.loading} onClose={() => LegislacaoStore.obs.loading = false} title={"Carregando"} />

        <Sidebar open={this.state.submenu} onClose={() => this.setState({ submenu: false })} isOpen={() => this.setState({ submenu: true })} />

        {UtilitarioStore.obs.open_equaliza_ncm && <EqualizaNcm onClose={this.onCloseEqualiza.bind(this)} />}

        <Dialog open={this.obs.notifyModal} onClose={() => this.obs.notifyModal = false}>
          <div className={Classes.DIALOG_BODY}>

            <h2 className="title-cert">Criar Notificação</h2>

            <WarningAdmin />

            <br />

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.notifyModal = false} />
            </div>

          </div>
        </Dialog>

        <Dialog open={this.obs.cronModal} onClose={() => this.obs.cronModal = false}>
          <div className={Classes.DIALOG_BODY}>

            <h2 className="title-cert">Cron (Liberar / Bloquear)</h2>

            <Cron />

            <br />

            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button text="Fechar" intent="primary" onClick={() => this.obs.cronModal = false} />
            </div>

          </div>
        </Dialog>
      </>
    );
  }
}

const tourConfig = [
  {
    selector: "[data-tut=\"warnings\"]",
    content:
      <>
        Verifique os <b>Serviços Indisponíveis</b> no momento.<br />
      </>,
  }
];
